<template functional>
    <b-jumbotron header="Resource Not Found" lead="There was an issue retrieving information on the resource you were looking for.">
      <b-btn href="/">Go To Dashboard</b-btn>
    </b-jumbotron>
</template>

<script>
export default {
	props: {
		offset: { default: true },
		cover: { default: false }
	}
};
</script>

<style scoped>

</style>
